import script from "./FullyWidgetContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./FullyWidgetContainer.vue?vue&type=script&setup=true&lang=ts"

import "./FullyWidgetContainer.vue?vue&type=style&index=0&id=bd6f9e8e&lang=scss"

const __exports__ = script;

export default __exports__